import { render, staticRenderFns } from "./FeCarlosNieto.vue?vue&type=template&id=c971ee70&"
import script from "./FeCarlosNieto.vue?vue&type=script&lang=js&"
export * from "./FeCarlosNieto.vue?vue&type=script&lang=js&"
import style0 from "./FeCarlosNieto.vue?vue&type=style&index=0&id=c971ee70&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports